import { useEffect } from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import FormGroup from '../FormGroup';

const DatePicker = ({
    id,
    name = 'datePicker',
    required,
    inline = true,
    showTimeSelect = true,
    timeInputLabel,
    fixedHeight = false,
    timeCaption = 'Time',
    timeIntervals = 30,
    minDate = new Date(),
    minTime = (() => {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    })(),
    maxTime = (() => {
        const d = new Date();
        d.setHours(23, 59, 59, 999);
        return d;
    })(),
    hasError = false,
    showWarningIcon = false,
    errorText = 'Date and time are required',
    includeTimes,
    selectedDate,
    ...rest
}) => {
    const scrollToSelectedTime = () => {
        const selectedTimeElement = document.querySelector('.react-datepicker__time-list-item--selected');

        if (selectedTimeElement) {
            const parentContainer = selectedTimeElement.parentElement;

            if (parentContainer) {
                // Calculate the position to center the selected time
                const elementOffset = selectedTimeElement.offsetLeft;
                const elementWidth = selectedTimeElement.offsetWidth;
                const containerWidth = parentContainer.offsetWidth;
                parentContainer.scrollLeft = elementOffset - containerWidth / 2 + elementWidth / 2;
            }
        }
    };

    // Center the selected time on mount or when the date changes
    useEffect(() => {
        scrollToSelectedTime();
    }, [selectedDate, includeTimes]);
    return (
        <FormGroup
            showError={hasError}
            externalErrorMessage={
                hasError && errorText ? (
                    <span className="error-message">
                        {showWarningIcon && (
                            <span role="img" aria-label="Warning">
                                <img
                                    className="warning-icon"
                                    src="/img/frontend/warning.svg"
                                    alt="Required field"
                                    width={24}
                                    height={24}
                                />
                            </span>
                        )}{' '}
                        {errorText}
                    </span>
                ) : null
            }
            required={required}
            name={name}
            id={id}
        >
            <div id={id} data-testid="date-picker" className={`${name} ${hasError ? `${name}-error` : ''}`}>
                <ReactDatePicker
                    className={name}
                    fixedHeight={fixedHeight}
                    required={required}
                    inline={inline}
                    showTimeSelect={showTimeSelect}
                    timeInputLabel={timeInputLabel}
                    minDate={minDate}
                    includeTimes={includeTimes}
                    minTime={minTime}
                    maxTime={maxTime}
                    timeCaption={timeCaption}
                    timeFormat="p"
                    timeIntervals={timeIntervals}
                    {...rest}
                />
            </div>
        </FormGroup>
    );
};

export default DatePicker;
